import { Component, OnInit } from '@angular/core';
import { Product } from '../../../interfaces/Product.interface';
import { Input } from '@angular/core';
import { Client } from '../../../interfaces/Client.interface';
import { AdvGrowlService } from 'primeng-advanced-growl';
import { TranslateService } from '@ngx-translate/core';
import { EnceService } from '../../../services/ence.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css'],
  providers: [EnceService]
})

export class DetalleComponent implements OnInit {



  public saldoActual:any;
  public saldoDespues:any;
  public cantidad:any;
  @Input() infoDetail: Product;
  public infoClient:Client;
  public cart: Array<any>;
  public cartProduct;

  public tallaArray: Array<any>;
  public tallaExist:boolean;
  public msgTalla:string;
  public size: string;
  public talla: string;

  constructor(
    private translate: TranslateService,
    private _serviceGrow: AdvGrowlService,
    public _enceService: EnceService
  ) { 
    
    this.cantidad=1;
    this.cart=[];
    this.talla='0';
    this.tallaArray=[];
    this.tallaExist=false;
  }

  ngOnInit() {
    if(localStorage.getItem('infoClient')){
      this.infoClient = JSON.parse(localStorage.getItem('infoClient'));
    }
    this.checkTallaExist();
    this.calcScoreLater();
    this.cantidad=1;
    this.saldoActual = this.infoClient.info.val_score;
  }

  public comprobarExisteProductoCarrito(idproducto:any):boolean{
    for(let car of this.cart){
      if(car.codprod == idproducto){
        return true;
      }else{
        return false;
      }
    }
  }

  public checkTallaExist(){
    if(this.infoDetail.size !== null){
      this.cantidad=1;
      this.tallaArray=this.infoDetail.size;
      this.tallaExist=true;
    }else{
      this.tallaExist=false;
      this.tallaArray=[];
    }
  }


  /**
   * Aumentar cantidad
   */
  public aumentarCantidad():void{
    this.cantidad = this.cantidad + 1;
    this.calcScoreLater();
  }

  /**
   * Reducir cantidad
   */
  public reducirCantidad():void{

    if(this.cantidad > 1){
      this.cantidad = this.cantidad - 1;
    }
    this.calcScoreLater();
  }



  /**
   * Calculo de puntos despues de compra con producto
   */
  public calcScoreLater():void{
    let tot:any;
    tot = parseFloat(this.infoClient.info.val_score) - (this.cantidad * parseFloat(this.infoDetail.cost));
    this.saldoDespues=tot;

  }

  /**
   * Funcion que calcula el total de la compra
   */
  public calcTotBuy(){
    let tot:any=0;
    tot = this.cantidad * parseFloat(this.infoDetail.cost);
    return tot;
  }

  /**
   * Funcion que carga el producto en el carrito
   */
  public addCartProduct(codprod){
      if(!this.tallaExist){
        this.cartProduct={};
      if(!localStorage.getItem('cartsilvicola')){
        this.cartProduct.cantidad=this.cantidad;
        this.cartProduct.codprod=codprod;
        this.cartProduct.descripcion=this.infoDetail.description;
        this.cartProduct.url = this.infoDetail.picture.url;
        this.cartProduct.title=this.infoDetail.title;
        this.cartProduct.size = [];
        this.cartProduct.score=this.infoDetail.cost;
        this.cart.push(this.cartProduct);
        localStorage.setItem('cartsilvicola',JSON.stringify(this.cart));
      }else{
        //this.checkExistProdCart(codprod);
        this.cart = JSON.parse(localStorage.getItem('cartsilvicola'));
        if(this.comprobarExisteProductoCarrito(codprod)){
          for(let car of this.cart){
            if(car.codprod == codprod){
              car.cantidad = car.cantidad + this.cantidad;
            }
          }
        }else{
          this.cartProduct.cantidad=this.cantidad;
          this.cartProduct.codprod=codprod;
          this.cartProduct.url = this.infoDetail.picture.url;
          this.cartProduct.title=this.infoDetail.title;
          this.cartProduct.size = [];
          this.cartProduct.descripcion=this.infoDetail.description;
          this.cartProduct.score=this.infoDetail.cost;
          this.cart.push(this.cartProduct);
        }
        
        localStorage.setItem('cartsilvicola',JSON.stringify(this.cart))
      }
      this.cantidad=1;
      this._serviceGrow.createSuccessMessage(this.translate.get('ence.cart-product-added')['value'], 'Enviado');
      }else{
        if(this.talla!=='0'){
          this.cartProduct={};
      if(!localStorage.getItem('cartsilvicola')){
        this.cartProduct.cantidad=this.cantidad;
        this.cartProduct.codprod=codprod;
        this.cartProduct.descripcion=this.infoDetail.description;
        this.cartProduct.url = this.infoDetail.picture.url;
        this.cartProduct.title=this.infoDetail.title;
        this.cartProduct.talla=this.talla;
        this.cartProduct.size = this.tallaArray;
        this.cartProduct.score=this.infoDetail.cost;
        this.cart.push(this.cartProduct);
        localStorage.setItem('cartsilvicola',JSON.stringify(this.cart));
      }else{
        this.cart = JSON.parse(localStorage.getItem('cartsilvicola'));
        this.cartProduct.cantidad=this.cantidad;
        this.cartProduct.codprod=codprod;
        this.cartProduct.url = this.infoDetail.picture.url;
        this.cartProduct.title=this.infoDetail.title;
        this.cartProduct.talla=this.talla;
        this.cartProduct.size = this.tallaArray;
        this.cartProduct.descripcion=this.infoDetail.description;
        this.cartProduct.score=this.infoDetail.cost;
        this.cart.push(this.cartProduct);
        localStorage.setItem('cartsilvicola',JSON.stringify(this.cart))
      }
      this.cantidad=1;
      this._serviceGrow.createSuccessMessage(this.translate.get('ence.cart-product-added')['value'], 'Enviado');
        }else{
          this._serviceGrow.createInfoMessage(this.translate.get('ence.talla-required')['value'],this.translate.get('ence.campo-obligatorio').toString());
        }
      }
      

      
  }

  /**
   * Check si el producto ya existe en el carrito lo modifica
   */
  public checkExistProdCart(codprod){
    let auxcart = JSON.parse(localStorage.getItem('cartsilvicola'));
    let aux:any=0;
    for(let prod of auxcart){      
      
      if(parseFloat(prod.codprod) === parseFloat(codprod)){
        auxcart.splice(aux, 1);
      }
      aux++;
    }
    localStorage.setItem('cartsilvicola',JSON.stringify(auxcart));
  }

    /**
     * Funcion que nos dice si el usuario tiene permisos de propietario para el catalogo lúdico y mas datos
     */
    public havePermissionsBuy():boolean{
      if(this.infoClient.category.id == '4' && this.infoClient.level.id == '14'){
        return false;
      }else{
        return true;
      }
    }

}
